import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    {
        path: "/loginMenu",
        name: "loginMenu",
        component: () => import("../views/loginMenu.vue"),
    },
    {
        path: "/personalMenu",
        name: "personalMenu",
        component: () => import("../views/personalMenu.vue"),
    },

    {
        path: "/",
        name: "homeMenu",
        component: () => import("../views/homeMenu.vue"),
        children: [

            {
                path: '/orderMenu',
                name: 'orderMenu',
                component: () => import("../views/orderMenu.vue"),
            },
            {
                path: '/orderSettings',
                name: 'orderSettings',
                component: () => import("../views/orderSettings.vue"),
            },
            {
                path: '/refundsMenu',
                name: 'refundsMenu',
                component: () => import("../views/refundsMenu.vue"),
            },
            {
                path: '/returnSetting',
                name: 'returnSetting',
                component: () => import("../views/returnSetting.vue"),
            },
            // 需求单管理
            {
                path: '/demandList',
                name: 'demandList',
                component: () => import("../views/demandList.vue"),
            },
            // 商品管理
            {
                path: '/commodityClass',
                name: 'commodityClass',
                component: () => import("../views/commodityClass.vue"),
            },
            {
                path: '/commodityList',
                name: 'commodityList',
                component: () => import("../views/commodityList.vue"),
            },
            {
                path: '/freightSetting',
                name: 'freightSetting',
                component: () => import("../views/freightSetting.vue"),
            },
            // 网站管理
            {
                path: '/homeManage',
                name: 'homeManage',
                component: () => import("../views/homeManage.vue"),
            },
            {
                path: '/bannerManage',
                name: 'bannerManage',
                component: () => import("../views/bannerManage.vue"),
            },
            {
                path: '/newsSetting',
                name: 'newsSetting',
                component: () => import("../views/newsSetting.vue"),
            },
            {
                path: '/userAgreement',
                name: 'userAgreement',
                component: () => import("../views/userAgreement.vue"),
            },
            // 系统管理
            {
                path: '/usernamSetting',
                name: 'usernamSetting',
                component: () => import("../views/usernamSetting.vue"),
            },
            {
                path: '/accountSetting',
                name: 'accountSetting',
                component: () => import("../views/accountSetting.vue"),
            },
            {
                path: '/roleSetting',
                name: 'roleSetting',
                component: () => import("../views/roleSetting.vue"),
            },
            // 测试
            {
                path: '/yy',
                name: 'yy',
                component: () => import("../views/yy.vue"),
            },
            {
                path: '/yy2',
                name: 'yy2',
                component: () => import("../views/yy2.vue"),
            },

        ]
    },
];

const router = new VueRouter({
    routes,
});

// 导航守卫
router.beforeEach((to, from, next) => {
    // 检查用户是否已登录   // ❗️避免无限重定向
    let token = sessionStorage.getItem("token");
    if (!token && to.name !== 'loginMenu') {
        // 将用户重定向到登录页面
        next({ path: "/loginMenu" });
    } else {
        next();
    }
})


export default router;
